import { STATES } from '../../../constants';

export const GetStartedAddressConfig = $stateProvider => {
  'ngInject';
  $stateProvider.state(STATES.GET_STARTED_2, {
    url: '/2',
    disableBreadcrumb: true,
    scrollTop: true,
    analytics: {
      page: 'Get Started: Addresses',
      success: 'Saved Addresses',
    },
    views: {
      'form@app.get-started': {
        template: '<upd-get-started-address></upd-get-started-address>',
      },
    },
    data: {
      header: 'Ok, almost done!',
      subHeader: `Just a bit more info and we're ready to go.`,
      prev: STATES.GET_STARTED_1,
      next: STATES.DASHBOARD_SIGNUP_COMPLETE,
      stepIndicatorIndex: 1,
    },
  });
};
